"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersExpandedState_1 = __importDefault(require("./ProvidersExpandedState"));
var ProvidersDefaultState_1 = __importDefault(require("./ProvidersDefaultState"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var SearchButton_1 = __importDefault(require("./SearchButton"));
var ProvidersWithSearch = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var config = (0, swr_hooks_1.useConfig)();
    var _a = (0, react_1.useState)(false), viewAll = _a[0], setViewAll = _a[1];
    var cancelViewAll = (0, react_1.useCallback)(function () {
        setViewAll(false);
    }, [setViewAll]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h1", null, t('leadingProviders')),
                !viewAll && (react_1.default.createElement(react_1.default.Fragment, null, (config === null || config === void 0 ? void 0 : config.searchButtonInProvidersHomePage) ? (react_1.default.createElement(SearchButton_1.default, { onClick: function () { return setViewAll(!viewAll); } })) : (react_1.default.createElement("button", { onClick: function () { return setViewAll(!viewAll); }, className: "".concat(viewAll ? styles_module_scss_1.default.active : ''), style: { whiteSpace: 'nowrap' } }, t('viewAll'))))))),
        viewAll ? (react_1.default.createElement(ProvidersExpandedState_1.default, { cancelViewAll: cancelViewAll })) : (react_1.default.createElement(ProvidersDefaultState_1.default, null))));
};
exports.default = ProvidersWithSearch;
